const r = (e) => ({
  text: e.properties?.text?.markup,
  header: e.properties?.header
});
export {
  r as factBoxDeliveryApiParser
};
